// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SettingsCatalogs-skeleton__Gg8bW{display:flex;flex-direction:column;gap:var(--size-4);width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": "SettingsCatalogs-skeleton__Gg8bW"
};
export default ___CSS_LOADER_EXPORT___;
